import React from 'react';
import {withMeta, withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

/**
 * In June 2023, we removed exposing this Container as a preset in the Layouts plugin.
 * But we still need to keep it around for existing sites that have added it.
 */
const Container = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
    const Tag = data.tag;
    const containerClasses = classes.push('w-container');
    return (
      <Tag {...generateAttributes(attributes, containerClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Container',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Div')),
  },
  showEmpty: true,
  lockedStyles: {
    float: {
      when: true,
      message: 'Containers should not be floated.',
    },
    marginLeft: {
      when: true,
      message: 'Container margins are locked to keep it responsive.',
    },
    marginRight: {
      when: true,
      message: 'Container margins are locked to keep it responsive.',
    },
    width: {
      when: true,
      message:
        'Container width is locked to keep it responsive. Edit max-width to change the container size.',
    },
    minWidth: {
      when: true,
      message:
        'Container width is locked to keep it responsive. Edit max-width to change the container size.',
    },
  },
  render: Container,
  fields: {
    children: TListOfElement,
    tag: withMeta(
      {variant: 'menu'},
      withSystem(
        {
          defaultValue: 'div',
          label: 'Tag',
          private: true,
          isLocalizable: true,
        },
        TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
      )
    ),
  },
});

export default config;
